export default "__VITE_ASSET__7Dc6BpBu__"